$(document).ready(function() {
  // Card More Button Js

  $('.collection-featured-grid-item').each(function() {
    var $blogSection = $(this);    
    $blogSection.find('.card__content-variant').each(function() {
    var $this = $(this);      
      var $swatchList = $this.find('.block_collection_grid_swatch_list');      
      var CollectionSwatchList = $swatchList.length;

      if (CollectionSwatchList > 6) {    
        $swatchList.eq(5).nextAll().hide().addClass('toggleable_swatch');
      }  
    });
  });

   // $('.more-swatch').unbind().click(function(e) {
   //   e.preventDefault();
   //    var $this = $(this);
   //    var $toggleableSwatches = $this.parents('.collection-featured-grid-item').find('.toggleable_swatch');
   //    if ($this.hasClass('more-item')) {    
   //      $this.text('- Less').removeClass('more-item'); 
   //    } else {
   //       $this.text('+ More').addClass('more-item');    
   //    }
   //    $toggleableSwatches.slideToggle();
   //  });

});


// Card Product
$(document).on('click', '.block_collection_grid_swatch_list', function() {  
    var variant_id = $(this).data('id');
    $(this).closest('.collection-featured-grid-item').find('form input[name="id"]').val(variant_id);
    $(this).closest('.collection-featured-grid-item').find('.card__content-variant .block_collection_grid_swatch_list').removeClass('value-color-active');
    $(this).addClass('value-color-active');
    var image_url = $(this).attr('data-image-url');
    $(this).closest('.collection-featured-grid-item').find('.card__media img').attr('srcset', image_url);
});

// Tag Js Collection Wise Filter
var tabElements = document.querySelectorAll('.block__multicollection-tabinner');
  tabElements.forEach(function(tabElement) {
    tabElement.addEventListener('click', function() {
      var parentTabInner = this.closest('.block__multicollection-tabinner');
      var currentTab = parentTabInner.getAttribute('data-collectionheading');
      var allTabInners = document.querySelectorAll('.block__multicollection-tabinner');
      allTabInners.forEach(function(inner) {
        inner.classList.remove('block__multicollection-tabactive');
      });
      parentTabInner.classList.add('block__multicollection-tabactive');
      var allItemLists = document.querySelectorAll('.block__multicollection--itemlist');
      allItemLists.forEach(function(itemList) {
        itemList.classList.remove('block__multicollection--itemactive');
      });
      document.querySelector('.block__multicollection--itemlist[data-collectionheading="'+currentTab+'"]').classList.add('block__multicollection--itemactive');;
      $('.block__multicollection--itemlistwrap').slick('refresh');
    });
});

